// Debit card contact dialogs (Contacts, Send Funds, Request Funds). See routes/Transfer/components/ContactFields.
export const contactFieldsEn = {
  'contact-fields-card-number-label-push': 'Recipient\'s Card Number',
  'contact-fields-card-number-hint-push':
    'The 16-19 digit number on the front of the card you\'re sending to.',
  'contact-fields-card-number-label-pull': 'Contact\'s Card Number',
  'contact-fields-card-number-hint-pull':
    'The 16-19 digit number on the front of the card you\'re requesting funds from.',
  'contact-fields-country-canada': 'Canada',
  'contact-fields-expiry-placeholder': 'MM/YYYY',
  'contact-fields-province-AB': 'Alberta',
  'contact-fields-province-BC': 'British Columbia',
  'contact-fields-province-MB': 'Manitoba',
  'contact-fields-province-NB': 'New Brunswick',
  'contact-fields-province-NL': 'Newfoundland and Labrador',
  'contact-fields-province-NS': 'Nova Scotia',
  'contact-fields-province-NU': 'Nunavut',
  'contact-fields-province-NT': 'Northwest Territories',
  'contact-fields-province-ON': 'Ontario',
  'contact-fields-province-PE': 'Prince Edward Island',
  'contact-fields-province-QC': 'Quebec',
  'contact-fields-province-SK': 'Saskatchewan',
  'contact-fields-province-YT': 'Yukon',

  'contact-fields-errors-name-required': 'Enter a name for this contact.',
  'contact-fields-errors-name-invalid': 'Use 3 to 80 letters, numbers, spaces or hyphens.',
  'contact-fields-errors-fullName-required': 'Enter the name printed on the card.',
  'contact-fields-errors-cardNumber-required': 'Enter the card number.',
  'contact-fields-errors-cardNumber-invalid': 'A card number is 16 to 19 digits.',
  'contact-fields-errors-expiry-invalid': 'Enter the expiry date as MM/YYYY, for example 08/2028.',
  'contact-fields-errors-cvv-invalid': 'Enter the 3-digit code from the back of the card.',
  'contact-fields-errors-addressLineOne-required': 'Enter the street address.',
  'contact-fields-errors-city-required': 'Enter the city.',
  'contact-fields-errors-state-required': 'Select a province.',
  'contact-fields-errors-postalCode-required': 'Enter the postal code.',
  'contact-fields-errors-postalCode-invalid': 'Enter a postal code in the format A1A 1A1.',
  'contact-fields-errors-firstName-required': 'Enter the first name.',
  'contact-fields-errors-firstName-invalid': 'A first name cannot include @.',
  'contact-fields-errors-lastName-required': 'Enter the last name.',
  'contact-fields-errors-lastName-invalid': 'A last name cannot include @.',
  'contact-fields-errors-email-required': 'Enter the email address.',
  'contact-fields-errors-email-invalid': 'Enter an email address like name@example.com.',
  'contact-fields-errors-confirmEmail-required': 'Enter the email address again.',
  'contact-fields-errors-confirmEmail-mismatch': 'The email addresses do not match.',
};

export const contactFieldsFr = {
  'contact-fields-card-number-label-push': 'Numéro de carte du destinataire',
  'contact-fields-card-number-hint-push':
    'Le numéro de 16 à 19 chiffres inscrit au recto de la carte à laquelle vous envoyez des fonds.',
  'contact-fields-card-number-label-pull': 'Numéro de carte du contact',
  'contact-fields-card-number-hint-pull':
    'Le numéro de 16 à 19 chiffres inscrit au recto de la carte d\'où proviendront les fonds.',
  'contact-fields-country-canada': 'Canada',
  'contact-fields-expiry-placeholder': 'MM/AAAA',
  'contact-fields-province-AB': 'Alberta',
  'contact-fields-province-BC': 'Colombie-Britannique',
  'contact-fields-province-MB': 'Manitoba',
  'contact-fields-province-NB': 'Nouveau-Brunswick',
  'contact-fields-province-NL': 'Terre-Neuve-et-Labrador',
  'contact-fields-province-NS': 'Nouvelle-Écosse',
  'contact-fields-province-NU': 'Nunavut',
  'contact-fields-province-NT': 'Territoires du Nord-Ouest',
  'contact-fields-province-ON': 'Ontario',
  'contact-fields-province-PE': 'Île-du-Prince-Édouard',
  'contact-fields-province-QC': 'Québec',
  'contact-fields-province-SK': 'Saskatchewan',
  'contact-fields-province-YT': 'Yukon',

  'contact-fields-errors-name-required': 'Entrez un nom pour ce contact.',
  'contact-fields-errors-name-invalid': 'Utilisez de 3 à 80 lettres, chiffres, espaces ou traits d\'union.',
  'contact-fields-errors-fullName-required': 'Entrez le nom inscrit sur la carte.',
  'contact-fields-errors-cardNumber-required': 'Entrez le numéro de carte.',
  'contact-fields-errors-cardNumber-invalid': 'Un numéro de carte comporte de 16 à 19 chiffres.',
  'contact-fields-errors-expiry-invalid': 'Entrez la date d\'expiration au format MM/AAAA, par exemple 08/2028.',
  'contact-fields-errors-cvv-invalid': 'Entrez le code à 3 chiffres au verso de la carte.',
  'contact-fields-errors-addressLineOne-required': 'Entrez l\'adresse.',
  'contact-fields-errors-city-required': 'Entrez la ville.',
  'contact-fields-errors-state-required': 'Sélectionnez une province.',
  'contact-fields-errors-postalCode-required': 'Entrez le code postal.',
  'contact-fields-errors-postalCode-invalid': 'Entrez un code postal au format A1A 1A1.',
  'contact-fields-errors-firstName-required': 'Entrez le prénom.',
  'contact-fields-errors-firstName-invalid': 'Un prénom ne peut pas contenir @.',
  'contact-fields-errors-lastName-required': 'Entrez le nom de famille.',
  'contact-fields-errors-lastName-invalid': 'Un nom de famille ne peut pas contenir @.',
  'contact-fields-errors-email-required': 'Entrez l\'adresse courriel.',
  'contact-fields-errors-email-invalid': 'Entrez une adresse courriel comme nom@exemple.com.',
  'contact-fields-errors-confirmEmail-required': 'Entrez l\'adresse courriel à nouveau.',
  'contact-fields-errors-confirmEmail-mismatch': 'Les adresses courriel ne correspondent pas.',
};
